<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Manage User Access" subTitle="Forms" />

    <AccessRole />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import AccessRole from "@/components/Pages/Master/Role/AccessRole.vue";

export default defineComponent({
  name: "AccessRolePage",
  components: {
    PageTitle,
    AccessRole,
  },
});
</script>
